export default "__VITE_ASSET__BwrP627D__"